module.exports = __webpack_public_path__ + "img/service_center_001.c164c966.png";